
import { Component, Prop } from "vue-property-decorator";
import StandardLayout from "../../components/layout/standard-layout/StandardLayout.vue";
import { StoreReturnDeliveryPackageView } from "../../../generated/contracts";
import Api from "../../../core/api/Api";
import StorePickupInfo from "../store/StorePickupInfo.vue";

@Component
export default class StoreReturnPackagePage extends StandardLayout<StoreReturnDeliveryPackageView> {

    @Prop() private id!: string;
    @Prop() private storeAccountNumber!: string;

    protected async created() {
        this.pageView = await Api.store.getStoreReturnPackagePage(this.storeAccountNumber, this.id);
        this.sections = [
            {
                name: "Afhentningsinfo",
                component: StorePickupInfo,
                props: {
                    pickupInfo: this.pageView.content.pickupInfo
                },
                events: {
                    shareInfo: this.returnInfoShareInfo
                }
            }
        ];
    }

    private returnInfoShareInfo(target: "customer" | "colleague", name: string, email: string, message: string, images: string[]) {
        Api.returnDeliveryPackage.share(target, this.id, name, email, message, images);
    }
}
